import api from "./index";
import generateHeaders from "../utils/generateHeaders.js";

export const getAllTotems = async ({ token }) => {
  const headers = generateHeaders(token);

  return await api.get("/totem-manage-access", {
    ...headers,
  });
};

export const createTotem = async ({ token, data }) => {
  const headers = generateHeaders(token);

  return await api.post("/totem-manage-access", data, headers);
};

export const getTotemById = async ({ token, id }) => {
  const headers = generateHeaders(token);

  return await api.get(`/totem-manage-access/${id}`, headers);
};

export const updateTotem = async ({ token, id, data }) => {
  const headers = generateHeaders(token);

  return await api.put(`/totem-manage-access/${id}`, data, headers);
};

export const deleteTotem = async ({ token, id }) => {
  const headers = generateHeaders(token);

  return await api.delete(`/totem-manage-access/${id}`, headers);
};

export const getAllCredentialTemplates = async ({ token }) => {
  const headers = generateHeaders(token);

  return await api.get("/credential-templates", {
    ...headers,
  });
};

export const createCredentialTemplate = async ({ token, data, eventId }) => {
  const headers = generateHeaders(token);

  return await api.post(
    `/events/${eventId}/credential-templates`,
    data,
    headers
  );
};

export const getCredentialTemplateById = async ({
  token,
  eventId,
  modelId,
}) => {
  const headers = generateHeaders(token);

  return await api.get(
    `/events/${eventId}/credential-templates/${modelId}`,
    headers
  );
};

export const updateCredentialTemplate = async ({
  token,
  eventId,
  modelId,
  data,
}) => {
  const headers = generateHeaders(token);

  return await api.put(
    `/events/${eventId}/credential-templates/${modelId}`,
    data,
    headers
  );
};

export const deleteCredentialTemplate = async ({ token, eventId, modelId }) => {
  const headers = generateHeaders(token);

  return await api.delete(
    `/events/${eventId}/credential-templates/${modelId}`,
    headers
  );
};

export const getAllCredentialsByEvent = async ({ token, eventId }) => {
  const headers = generateHeaders(token);
  return await api.get(`/events/${eventId}/credential-templates`, headers);
};

//Dashboard for monitoring the totems
export const getDashboardStats = async ({
  token,
  eventId, // obrigatório
  totemId,
  position,
  credentialType,
  status, // ALL | SUCCESS | ERROR
  year,
}) => {
  const headers = generateHeaders(token);

  return await api.get("/dashboard/stats", {
    ...headers,
    params: {
      eventId,
      ...(totemId && { totemId }),
      ...(position && { position }),
      ...(credentialType && { credentialType }),
      ...(status && { status }),
      ...(year && { year }),
    },
  });
};

const configDashboardParams = async ({
  token,
  endpoint,
  eventId,

  totemId,
  position,
  credentialType,
  printStatus,
  year,

  page = 0,
  size = 10,
  sort = "ASC",
  search,
}) => {
  const headers = generateHeaders(token);

  return await api.get(endpoint, {
    ...headers,
    params: {
      eventId,

      ...(totemId && { totemId }),
      ...(position && { position }),
      ...(credentialType && { credentialType }),
      ...(printStatus && { printStatus }),
      ...(year && { year }),

      page,
      size,
      sort,

      ...(search && { search }),
    },
  });
};

export const getDashboardLogs = async (params) => {
  return configDashboardParams({
    ...params,
    endpoint: "/dashboard/logs",
  });
};

export const exportDashboardLogs = async (params) => {
  return configDashboardParams({
    ...params,
    endpoint: "/dashboard/logs/export",
  });
};
